(function () {
    const items = jQuery('.usp-bar__item');
    const duration = 3000;
    const showFor = 2000;

    function doAnimation() {
        jQuery(items).each(function(i) {
            // Reset z-index so that first item can be clicked
            // (and opacity to ensure it reset properly)
            if (i === 0) {
                jQuery(this).css({zIndex: 1, opacity: 0});
            } else {
                jQuery(this).css({zIndex: 0, opacity: 0});
            }

            jQuery(this).delay( i * (duration + showFor) ).animate({opacity: 1}, duration, function () {
                // Delay the opacity reset
                jQuery(this).delay(showFor).queue(function (next) {
                    // Reset opacity and z-index for item
                    jQuery(this).css({zIndex: 0, opacity: 0});

                    // Update z-index for next item in animation queue
                    if (!(i === jQuery(items).length - 1)) {
                        jQuery(jQuery(items).get(i + 1)).css({zIndex: 1});
                    }
                    next();
                }).queue(function (next) {
                    /* If last one re-run it
                     * Changed to this so no chance of it running twice
                     * (if first one lags the interval will still trigger second)
                     */
                    if (i === jQuery(items).length - 1) {
                        doAnimation();
                    }
                    next();
                });
            });
        });
    }
    doAnimation();
}());
